import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrimengModule } from '@gestor-web/app/shared/modules';
import { PageCardContainerComponent } from './page-card-container.component';
import { BlendusPipesModule } from '@gestor-web/app/shared/pipes/pipes.module';

@NgModule({
  declarations: [PageCardContainerComponent],
  exports: [PageCardContainerComponent],
  imports: [CommonModule, PrimengModule, BlendusPipesModule],
})
export class PageCardContainerModule {}
